import * as React from 'react'
import Link from 'next/link'
import { BlogPostType } from '../../pages/blog'
// import { HeroForm } from '../Forms/ScheduleServiceMultiStep/HeroForm'
import { useQueryParam } from '../../hooks/useQueryParam'
import { Button } from '../Button'
type Props = {
  posts: BlogPostType[]
}
export const BlogSidebar: React.FC<Props> = ({ posts }) => {
  const query = useQueryParam()
  return (
    <div>
      <div
        style={{
          padding: '10px',
          border: '1px solid #d8d8d8',
          borderTop: '13px solid #f04e23',
          boxShadow:
            '0 13px 27px -5px rgba(50,50,93,.25), 0 8px 16px -8px rgba(0,0,0,.3), 0 -6px 16px -6px rgba(0,0,0,.025)',
        }}
      >
        <h2 style={{ fontWeight: 800 }}>Brake problems? Schedule a free brake repair estimate now.</h2>
        {/*<HeroForm />*/}
        <Link href={{ pathname: '/', query }}>
          <a className={'text-white'}>
            <Button className={'block w-full mt-4 mb-2'}>Get A Quote</Button>
          </a>
        </Link>
      </div>
      <h4 style={{ paddingTop: 60, fontWeight: 700 }}>More Brake Posts</h4>
      <ul style={{ listStyleType: 'none', paddingLeft: 0 }}>
        {posts.map((post, index) => (
          <li style={{ paddingTop: 10 }} key={index}>
            <Link href={`/blog/[slug]`} as={{ pathname: `/blog/${post.slug}/`, query }}>
              <a>{post.title}</a>
            </Link>
          </li>
        ))}
      </ul>
    </div>
  )
}
